import { pharmacyClient } from '@/connect'
import { createFileRoute } from '@tanstack/react-router'
import BranchTransferStock from './-components'

export const Route = createFileRoute('/company/_layout/inventory/transfer-stock/' as any)({
  component: BranchTransferStock,
  loader: async () => {
    return await pharmacyClient.getBranchesForCompany({
      companyCode: '', 
    })
  }
})